import { render, staticRenderFns } from "./AccountTransactionCard.vue?vue&type=template&id=23aba81f"
import script from "./AccountTransactionCard.vue?vue&type=script&lang=js"
export * from "./AccountTransactionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports